import React, { Fragment, useEffect, useState } from "react";
//import { Tab, Nav, Spinner } from "react-bootstrap";
import Grid from "@mui/material/Unstable_Grid2";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
// import Tabs from "../common/Tabs";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import IconButton from "@mui/material/IconButton/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import TabPanel from "@mui/lab/TabPanel";
import { createTheme } from "@mui/system";
import CardCarousel from "../common/CardCarousel";
import { Project } from "../../types/project";
import TabConfig from "../../config/UserProjectsConfig.json";
import InputBase from "@mui/material/InputBase";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import TableDetails from "../common/TableDetails";
import { Stack } from "@mui/material";
import "./userProjects.css";

const UserProjects = (props: { projects: Project[]; search: string }) => {
  const theme = createTheme({
    palette: {
      background: {
        paper: "#fff",
      },
      text: {
        primary: "purple",
        secondary: "white",
      },
      action: {
        active: "darkblue",
      },
      success: {
        dark: "#fff",
      },
    },
  });
  // const [visibleApps, setVisibleApps] = useState(props.projects);
  const [value, setValue] = React.useState("0");
  const [noActiveSearch, setNoActiveSearch] = React.useState(true);
  const [tabName, setTabName] = React.useState(TabConfig[0]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [projectList, setProjectList] = React.useState<any>({
    ACTIVE:[], INACTIVE:[]
  });
  const [searchTerm, setSearchTerm] = React.useState("");
  const searchRef = React.useRef<HTMLInputElement>(null);

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    console.log("Tab Value", newValue);
    setValue(newValue);
    setTabName(TabConfig[Number(newValue)]);
  };

  const getProjectsByTab = (tabName: string) => {
    console.log("Total Applist:", props);
    const projectList = props.projects.filter((item) =>
      tabName === "INACTIVE"
        ? item.Status === "Inactive"
        : item.Status !== "Inactive"
    );
    console.log(`Applist by ${tabName}:`, projectList);
    return projectList;
  };

  const handleSearchChange = (event: React.MouseEvent<HTMLElement>) => {
    console.log("Set SEARCH Term:", searchRef.current?.value);
    if (searchRef.current) {
      setSearchTerm(searchRef.current.value);
      setNoActiveSearch(false);
    }
  };
  const handleClearSearch = (event: React.MouseEvent<HTMLElement>) => {
    if (searchRef.current) {
      searchRef.current.value = "";
      setSearchTerm("");
      setNoActiveSearch(true);
    }
  };

  useEffect(() => {
    console.log("props.projects", props.projects);
    if (props.projects.length > 0) {
      setIsLoading(false);
      let activeList = getProjectsByTab("ACTIVE")
      let inactiveList = getProjectsByTab("INACTIVE")
      setProjectList({ACTIVE: activeList, INACTIVE: inactiveList})
      console.log("props.projects projectList", projectList);
    } else {
      setIsLoading(true);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.projects, props.projects.length]);

  return (
    <Fragment>
      <Box sx={{ width: "100%", typography: "body1" }}>
        <TabContext value={value}>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              textColor: "#f1f2f6",
              backgroundColor: "#366aaf",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-evenly",
            }}
          >
            {/* <Stack  direction="row" justifyContent="space-between"> */}
            <TabList
              className='tablist'
              onChange={handleChange}
              aria-label='Project List by Status'
              value={value}
              textColor='secondary'
              indicatorColor='secondary'
            >
              {TabConfig.map((ele, index) => (
                <Tab
                  className='tab'
                  label={ele.tabTitle + " PROJECTS"}
                  value={index.toString()}
                  key={ele.tabTitle}
                  sx={{ marginRight: "80px" }}
                />
              ))}
            </TabList>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                mr: "2rem",
              }}
            >
              <InputBase
                sx={{
                  ml: 0,
                  pl: 2,
                  flex: 1,
                  backgroundColor: "whitesmoke",
                  minWidth: "20rem",
                  borderRadius: "5px",
                }}
                placeholder='Search by Project Name / Project ID...'
                inputProps={{ "aria-label": "search projects" }}
                inputRef={searchRef}
                onChange={() => {
                  setNoActiveSearch(true);
                }}
              />
              {noActiveSearch ? (
                <IconButton
                  type='button'
                  sx={{ p: "10px", color: "whitesmoke", borderBlock: "white" }}
                  aria-label='search'
                  onClick={handleSearchChange}
                >
                  <SearchIcon />
                </IconButton>
              ) : (
                <IconButton
                  type='button'
                  sx={{ p: "10px", color: "whitesmoke", borderBlock: "white" }}
                  aria-label='search'
                  onClick={handleClearSearch}
                >
                  <HighlightOffIcon />
                </IconButton>
              )}
            </Box>
            {/* </Stack> */}
          </Box>
          {TabConfig.map((ele, index) => (
            <TabPanel
              value={index.toString()}
              sx={{ width: "100%", p: 0, m: 0 }}
              key={ele.tabTitle}
            >
              <Grid
                xs
                className='header-pane'
                sx={{ backgroundColor: "#366aaf" }}
              ></Grid>
              <div className='home__card-carousel'>
                {
                  <div>
                    <TableDetails
                      cardArray={projectList[ele.tabTitle]}
                      search={searchTerm}
                      isLoading={isLoading}
                    />
                    {/* <CardCarousel
                      cardArray={getProjectsByTab(ele.tabTitle)}
                      search={searchTerm}
                    /> */}
                  </div>
                }
              </div>
            </TabPanel>
          ))}
        </TabContext>
      </Box>
    </Fragment>
  );
};

export default UserProjects;
